var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("rect", { width: "24", height: "24", rx: "4", fill: "#018489" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.1885 8.35286C16.4748 8.05344 16.9495 8.04273 17.2489 8.32894C17.5484 8.61515 17.5591 9.08991 17.2728 9.38933L10.7411 15.6472C10.4466 15.9553 9.95488 15.9563 9.65905 15.6495L6.72965 12.8894C6.44213 12.5913 6.45076 12.1165 6.74893 11.8289C7.0471 11.5414 7.52189 11.5501 7.80942 11.8482L10.1966 14.046L16.1885 8.35286Z", fill: "#fff" })
  );
});